import apiClient from '../apiClient';

class CompanyProfileService {
  constructor(user) {
    this.user = user;
  }

  toBackendFormat(data) {
    const { id, auth0Id, createdAt, updatedAt, ...rest } = data;
    return rest;
  }

  fromBackendFormat(data) {
    return data;
  }

  async getRecordsByUserId(userId) {
    try {
      const response = await apiClient.get('/company-profiles/me');
      return response ? this.fromBackendFormat(response) : null;
    } catch (err) {
      // Re-throw rate limit errors so they can be handled by the caller
      if (err?.status === 429) {
        throw err;
      }
      return null;
    }
  }

  async getRecordById(recordId) {
    const response = await apiClient.get(`/company-profiles/${recordId}`);
    return response ? this.fromBackendFormat(response) : null;
  }

  async createRecord(data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.post('/company-profiles', backendData);
    return this.fromBackendFormat(response);
  }

  async createOrUpdateRecord(data) {
    const existingRecord = await this.getRecordsByUserId(data.userId);
    if (existingRecord) {
      return await this.updateRecord(existingRecord.id, data);
    } else {
      return await this.createRecord(data);
    }
  }

  async updateRecord(recordId, data) {
    const backendData = this.toBackendFormat(data);
    const response = await apiClient.put(`/company-profiles/${recordId}`, backendData);
    return this.fromBackendFormat(response);
  }
}

export default CompanyProfileService;